// Module
var code = "Manage Tokens <i class=\"fa fa-info-circle icon-md after-heading\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" data-popover=\"Access VIP Manager in order to reset or deactivate a token or to view audit reports.\" aria-hidden=\"true\"></i> ";
// Exports
module.exports = code;